// C:\Users\green\szaportal\src\WebServer\NewGenome\modules\Home\Home.js
const oncoRiskConfig = {
  api: {
    baseUrl: 'https://service9002.szapfs.org',
    endpoints: {
      webserverCookie: '/webserver_cookie',
      uploads: '/outputs',          // legacy list (file-scanned)
      submitJob: '/jobs/submit',    // new
      jobStatus: '/jobs/status',    // new → append /:job_id
      jobResult: '/jobs/result',    // new → append /:job_id
      jobsByAccount: '/jobs/by-account', // new
      
      // [NEW] Endpoints for the chunked upload feature
      initializeUpload: '/jobs/upload/initialize',
      uploadChunk: '/jobs/upload/chunk',
      finalizeUpload: '/jobs/upload/finalize',

      // Enrichment analysis
      keggAnalysis: '/kegg-analysis'
    }
  }
};

export function getApiBaseUrl() {
  return oncoRiskConfig.api.baseUrl;
}

export function getApiEndpoint(endpoint) {
  const baseUrl = oncoRiskConfig.api.baseUrl;
  const path = oncoRiskConfig.api.endpoints[endpoint];
  if (!path) {
    console.error(`API endpoint "${endpoint}" is not defined in newgenome-config.js`);
    return null;
  }
  return `${baseUrl}${path}`;
}

export default oncoRiskConfig;